import { PasswordResetEnum } from "./auth/password-reset.enum";
import { DeleteAccountEnum } from "./meu-perfil/delete-account.enum";
import { ChangePasswordEnum } from "./my-profile/change-password.enum";
import { UnsavedDataSheetEnum } from "./my-profile/unsaved-data-sheet.enum";
import { DependentFormDataTestIdEnum } from "./dependents/dependent-form.enum";
import { DependentsListDataTestIdEnum } from "./dependents/dependents-list.enum";
import { ConfirmDeletionSheetEnum } from "./dependents/confirm-deletion-sheet.enum";
import { AboutUsEnum } from "./about-us/about-us.enum";
import { AppointmentsRequestCancelDataTestId } from "./appointments/appointments-request-cancel.enum";
import { AppointmentsRescheduleDataTestId } from "./appointments/appointments-reschedule.enum";
import { AppointmentsReviewDataTestId } from "./appointments/appointments-review.enum";
import { BlogDataTestIdEnum } from "./blog/blog.enum";
import { BranchLaboratoryEnum } from "./branch-laboratory/branch-laboratory.enum";
import { BranchEnum } from "./branch/branch.enum";
import { BranchesNearYouDataTestidEnum } from "./branhes-near-you/branches-near-you.enum";
import { CitiesDataTestidEnum } from "./cities/cities.enum";
import { CityDataTestidEnum } from "./cities/city.enum";
import { UiComponentsDataTestIdEnum } from "./common/ui-components-data-test-id.enum";
import { BreadcrumbDataTestId } from "./common/breadcrumb-data-test-id.enum";
import { CalendarDataTestId } from "./common/calendar-data-test-id.enum";
import { BoundaryStateEnum } from "./common/boundary-state.enum";
import { ToastEnum } from "./common/toast.enum";
import { EntityProfileEnum } from "./common/entity-profile-data-test-id.enum";
import { FooterDataTestIdEnum } from "./common/footer-data-test-id.enum";
import { GalleryDataTestId } from "./common/gallery-data-test-id.enum";
import { HeaderDataTestIdEnum } from "./common/header-data-test-id.enum";
import { SearchProceduresModalDataTestId } from "./common/search-procedures-modal-data-test-id.enum";
import { BreadcrumbDataTestIdEnum } from "./common/ui/breadcrumb-data-test-id.enum";
import { InputDataTestIdEnum } from "./common/ui/input-data-test-id.enum";
import { WorkingHoursDataTestId } from "./common/working-hours-data-test-id.enum";
import { CookiesFooterEnum } from "./cookies-footer/cookies-footer.enum";
import { EntityProcedureEnum } from "./entity-procedure/entity-procedure.enum";
import { ExamsDataTestIdEnum } from "./exams/exams.enum";
import { FaqDataTestId } from "./faq/faq-data-test-id.enum";
import { FavoritosEnum } from "./favoritos/favoritos.enum";
import { HomeDataTestIdEnum } from "./home/home-data-test-id.enum";
import { LocationDataTestIdEnum } from "./location/location-data-test-id.enum";
import { IndexingEnum } from "./indexing/indexing.enum";
import { LaboratoryProfileEnum } from "./laboratory/laboratory-profile.enum";
import { MarkdownTestIdEnum } from "./markdownId/markdown-test-id.enum";
import { PartnerProfileEnum } from "./partner/partner-profile.enum";
import { PartnerServicesEnum } from "./partner/partner-services.enum";
import { ServiceNetworkEnum } from "./service-network/service-network.enum";
import { WorkWithUsDataTestId } from "./work-with-us/work-with-us.datatestid";
import { LoginEnum } from "./auth/login.enum";
import { ProfileSheetTestIdEnum } from "./common/profile-sheet.enum";
import { MyProfileDataTestIdEnum } from "./my-profile/my-profile-data.enum";
import { SelectCityDataTestIdEnum } from "./common/select-city.enum";
const DataTestIdEnum = {
  ...AboutUsEnum,
  ...UiComponentsDataTestIdEnum,
  ...AppointmentsRequestCancelDataTestId,
  ...AppointmentsRescheduleDataTestId,
  ...AppointmentsReviewDataTestId,
  ...BlogDataTestIdEnum,
  ...BranchEnum,
  ...BranchesNearYouDataTestidEnum,
  ...BranchLaboratoryEnum,
  ...BreadcrumbDataTestId,
  ...BreadcrumbDataTestIdEnum,
  ...CalendarDataTestId,
  ...CitiesDataTestidEnum,
  ...CityDataTestidEnum,
  ...CookiesFooterEnum,
  ...EntityProcedureEnum,
  ...EntityProfileEnum,
  ...ExamsDataTestIdEnum,
  ...ExamsDataTestIdEnum,
  ...FaqDataTestId,
  ...FavoritosEnum,
  ...FooterDataTestIdEnum,
  ...GalleryDataTestId,
  ...HeaderDataTestIdEnum,
  ...HomeDataTestIdEnum,
  ...IndexingEnum,
  ...InputDataTestIdEnum,
  ...LaboratoryProfileEnum,
  ...LocationDataTestIdEnum,
  ...MarkdownTestIdEnum,
  ...PartnerProfileEnum,
  ...PartnerServicesEnum,
  ...SearchProceduresModalDataTestId,
  ...ServiceNetworkEnum,
  ...WorkingHoursDataTestId,
  ...WorkWithUsDataTestId,
  ...BoundaryStateEnum,
  ...ToastEnum,
  ...PasswordResetEnum,
  ...LoginEnum,
  ...ProfileSheetTestIdEnum,
  ...MyProfileDataTestIdEnum,
  ...SelectCityDataTestIdEnum,
  ...ChangePasswordEnum,
  ...UnsavedDataSheetEnum,
  ...DeleteAccountEnum,
  ...DependentFormDataTestIdEnum,
  ...DependentsListDataTestIdEnum,
  ...ConfirmDeletionSheetEnum
};
export {
  DataTestIdEnum
};
